import React                from 'react'
import data                 from "./data"
import { Link }             from "react-router-dom"    

const BlogCard = () => {
    return (
        <>
            {
                data.map((d) => (
                    <div className="blogs-wrapper">
                        <div className="blogs-wrapper-desc">
                            <img className="blogs-img" src="https://picsum.photos/200/300"/>
                            <h1 className="blog-title">{d.blog_title}</h1>
                            <p className="blog-desc">{d.blog_desc}</p>
                        </div>  
                        <div className="blogs-wrapper-dirc">
                            <span className="read-more">
                                <Link to="/blog/asdad">DEVAMINI OKU</Link>
                                <i className="fas fa-angle-double-right"></i>
                            </span>
                            <span className="time">{d.blog_time}</span>
                        </div>
                    </div>
                ))
            }
        </>
    )
}

export default BlogCard
